/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FaceASadIcon16Solid = forwardRef('FaceASadIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm-2.421-3.907C5.843 10.219 6.822 9.499 8 9.499c1.178 0 2.157.72 2.422 1.594a.75.75 0 1 0 1.435-.436C11.37 9.052 9.73 7.999 8 7.999c-1.73 0-3.37 1.053-3.857 2.658a.75.75 0 0 0 1.436.436Z" })));
});
